<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <editor :config="{id: gridConfig.id, api: 'InvoiceTypes/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'InvoiceTypesIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'InvoiceTypes' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
